import { useMediaQuery } from 'react-responsive';

export const useMediumDesktop = () => {
    return useMediaQuery({maxWidth: 1367});
};

export const useSmallDesktop = () => useMediaQuery({maxWidth: 1199});

export const useMediumGadget = () => useMediaQuery({maxWidth: 991});

export const useMobile = () => useMediaQuery({maxWidth: 767});
